import { render, staticRenderFns } from "./home.page.pug?vue&type=template&id=9a67800e&scoped=true&lang=pug&external"
import script from "./home.page.ts?vue&type=script&lang=js&external"
export * from "./home.page.ts?vue&type=script&lang=js&external"
import style0 from "./home.page.sass?vue&type=style&index=0&id=9a67800e&prod&lang=sass&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a67800e",
  null
  
)

export default component.exports